var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-menu_group_item" },
    [
      _c(
        "div",
        { staticClass: "level_one_wrap", on: { mousemove: _vm.onMousemove } },
        [
          _c(
            "CMenuItem",
            _vm._b(
              {
                staticClass: "cmenu_item_wrap",
                attrs: {
                  data: _vm.data,
                  isDisabled: true,
                  isUseCustomStr: _vm.$attrs.isFixedMenu,
                  customStr: _vm.data.meta.title,
                },
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.$attrs.isFixedMenu
                      ? (_vm.isShowChildren = !_vm.isShowChildren)
                      : null
                  },
                },
              },
              "CMenuItem",
              _vm.$attrs,
              false
            ),
            [
              _c("div", { staticClass: "icon_wrap" }, [
                _c("img", {
                  staticClass: "icon",
                  attrs: {
                    src: require("@/components/aiChat/images/svg/historyIcon.svg"),
                  },
                }),
              ]),
              _c(
                "template",
                { slot: "title" },
                [
                  _c(
                    "Tooltip",
                    _vm._b(
                      {
                        staticClass: "label",
                        attrs: {
                          data: _vm.data.meta,
                          disabled: true,
                          keyName: _vm.$attrs.isFixedMenu
                            ? "title"
                            : "packName",
                        },
                      },
                      "Tooltip",
                      _vm.$attrs,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm.data.meta.num !== null
                ? _c("template", { slot: "num" }, [
                    _c("div", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.data.meta.num)),
                    ]),
                  ])
                : _vm._e(),
              _vm.data.children && _vm.data.children.length
                ? _c("template", { slot: "arrow" }, [
                    _c("img", {
                      staticClass: "icon",
                      class: [
                        "arrow_icon",
                        _vm.isShowChildren ? "is-rotate" : "",
                      ],
                      attrs: {
                        src: require("@/components/aiChat/images/svg/arrowRightIcon.svg"),
                      },
                    }),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm.$attrs.isFixedMenu && _vm.data.children && _vm.data.children.length
        ? _c(
            "el-collapse-transition",
            [
              _c(
                "el-scrollbar",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowChildren,
                      expression: "isShowChildren",
                    },
                  ],
                  staticClass: "children_wrap",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "infinite-scroll",
                          rawName: "v-infinite-scroll",
                          value: () => {
                            _vm.onLoad()
                          },
                          expression:
                            "\n          () => {\n            onLoad()\n          }\n        ",
                        },
                      ],
                      staticStyle: { "padding-right": "16px" },
                      attrs: {
                        "infinite-scroll-disabled": _vm.isDisabledScrollProp,
                      },
                    },
                    _vm._l(_vm.data.children, function (e, i) {
                      return _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !e.meta.hidden,
                              expression: "!e.meta.hidden",
                            },
                          ],
                          key: i,
                          staticClass: "children_wrap__item",
                        },
                        [
                          _vm.formatTop(e, i).isShow
                            ? _c(
                                "div",
                                {
                                  class: [
                                    "top_wrap",
                                    _vm.formatTop(e, i).className,
                                  ],
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.formatTop(e, i).label) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "CMenuItem",
                            _vm._b(
                              {
                                class: [
                                  "cmenu_item_wrap",
                                  "children_wrap__item--cmenu",
                                  _vm.formatActiveRoute(e),
                                ],
                                attrs: { data: e.meta },
                                nativeOn: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.onRouter(e)
                                  },
                                },
                              },
                              "CMenuItem",
                              _vm.$attrs,
                              false
                            ),
                            [
                              _c(
                                "template",
                                { slot: "title" },
                                [
                                  _c(
                                    "Tooltip",
                                    _vm._b(
                                      {
                                        staticClass: "label",
                                        attrs: {
                                          data: e.meta,
                                          keyName: "title",
                                          scrollHeight: 300,
                                          "visible-arrow": true,
                                          placement: "top",
                                          disabled: true,
                                          enterable: false,
                                          "popper-class": `custom_tooltip_popper`,
                                        },
                                      },
                                      "Tooltip",
                                      _vm.$attrs,
                                      false
                                    )
                                  ),
                                ],
                                1
                              ),
                              e.meta.num !== null
                                ? _c("template", { slot: "num" }, [
                                    _c("div", { staticClass: "num" }, [
                                      _vm._v(_vm._s(e.meta.num)),
                                    ]),
                                  ])
                                : _vm._e(),
                              !e.meta.fixed
                                ? _c(
                                    "template",
                                    { slot: "operate" },
                                    [
                                      _c("Dropdown", {
                                        attrs: {
                                          list: _vm.operateList(e).Array,
                                          trigger: "hover",
                                          placement: "bottom-start",
                                          className: `menu_dropdown_class`,
                                        },
                                        on: {
                                          "on-click": ({ item, index }) =>
                                            _vm.onCommand(
                                              { ...item },
                                              { params: e, index: i }
                                            ),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function () {
                                                return [
                                                  _c("img", {
                                                    staticClass: "moreBtn",
                                                    attrs: {
                                                      src: require("@/components/aiChat/images/more.png"),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                      },
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.$attrs.isFixedMenu &&
      _vm.data.children &&
      _vm.data.children.length == 0
        ? _c(
            "div",
            { staticClass: "no_data_wrap" },
            [
              _c("CustomImage", {
                staticClass: "icon",
                attrs: {
                  url: require("@/components/aiChat/images/noData.png"),
                  isPreview: false,
                  fit: `scale-down`,
                  borderRadius: "0",
                },
              }),
              _c("div", { staticClass: "text" }, [_vm._v("暂无对话")]),
            ],
            1
          )
        : _vm._e(),
      _c("CDialog", {
        ref: "cDialog",
        attrs: { customClass: "c-menu_group-dialog" },
        on: {
          "on-update-form": (params) => {
            params.operateType == "RESET_NAME_FORM"
              ? _vm.$emit("on-reset-name", params)
              : null
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }